import { render, staticRenderFns } from "./ChatRefMention.vue?vue&type=template&id=677a7632&"
import script from "./ChatRefMention.vue?vue&type=script&lang=js&"
export * from "./ChatRefMention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports